// eslint-disable-next-line
import React from 'react';
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';

// Vars
import { themeVars } from '../../../config/styles';

const LoadMoreButton = (props) => {
  const { children } = props;

  const cssWrapper = css`
    display: flex;
    align-items: center;
    justify-content: center;

    .hexagon {
      position: relative;
      width: 128px;
      height: 73.9px;
      background-color: ${themeVars.root.primary};
      margin: 36.95px 0;

      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 0;
        border-left: 64px solid transparent;
        border-right: 64px solid transparent;
        left: 0; /* Fix for placement */
      }

      &:before {
        bottom: 100%;
        border-bottom: 36.95px solid ${themeVars.root.primary};
      }

      &:after {
        top: 100%;
        width: 0;
        border-top: 36.95px solid ${themeVars.root.primary};
      }
    }
  `;

  const cssContent = css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin: 0;
    color: #fff;
    text-transform: uppercase;
    font-weight: 500;
  `;

  const cssBtn = css`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  `;

  return (
    <div css={cssWrapper}>
      <button css={cssBtn} type="button" {...props}>
        <div className="hexagon">
          <div css={cssContent}>{children}</div>
        </div>
      </button>
    </div>
  );
};

LoadMoreButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoadMoreButton;
